import React from "react";

export type ViewTopBarParams = {
    ViewDatabaseSelector: React.FC;
    ViewBreadcrumbs: React.FC;
};

export const createViewTopBar = ({
    ViewDatabaseSelector = () => null,
    ViewBreadcrumbs = () => null,
}: ViewTopBarParams) => {
    const ViewTopBar = () => {
        return (
            <>
                <ViewBreadcrumbs />
                <ViewDatabaseSelector />
            </>
        );
    };
    return ViewTopBar;
};
